import {ru} from "./ru"
import {en} from "./en"
import {kk} from "./kk"

if (!String.format) {
  String.format = function (format) {
    var args = Array.prototype.slice.call(arguments, 1);
    return format.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] != 'undefined'
          ? args[number]
          : match
          ;
    });
  };
}

export const Message = {
  ru : ru,
  en : en,
  kk : kk
};

